/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.imageEditorModule')
  .controller('ImageEditorController', ImageEditorController);

/**
 * AngularJS controller for imageEditor.
 */
function ImageEditorController() {
  this.isActive = false;
  this.isMoving = false;
  this.isAtBottom = false;
  this.isCanceled = false;
  this.isCommitted = false;
  this.isDeleted = false;
  this.enableButtons = false;
}
